import type { Entity } from '@column/api';

import { EntityTypes } from '../Edit';

export enum Mode {
  Live = 'live',
  Sandbox = 'sandbox',
}

export interface RootEntityOutletContext {
  mode: Mode;
  formType: EntityTypes | undefined;
  sandboxRootEntity: Entity | null | undefined;
  liveRootEntity: Entity | null | undefined;
  isSandboxLoading: boolean;
  isLiveLoading: boolean;
  handleSubmit: () => void;
  setFormType: (type: EntityTypes) => void;
  resetForm: (entityType: EntityTypes, entity: Entity | null) => void;
}
